import React from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";
import "bootstrap/dist/css/bootstrap.min.css";
import { formatDateTime } from "../../common-data/Converts";

const FeedbackCards = ({
  feedbackData,
  setModValues,
  handleDelete,
  isUpdateDelete,
}) => {
  return (
    <Row className="g-4">
      {feedbackData?.length > 0 ? (
        feedbackData.map((feedback, index) => {
          const rating = Number(feedback?.rating || 0);

          return (
            <Col key={index} md={4} className="m-0 pt-0 mt-5">
              <Card className="shadow-sm">
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <span>
                    <strong>{feedback.user_name}</strong>
                    &nbsp;
                    <Badge bg="info" className="text-capitalize">
                      {feedback.account_type}
                    </Badge>
                  </span>
                  <span className="text-muted small">
                    {feedback.date_added
                      ? formatDateTime(feedback.date_added)
                      : "-"}
                  </span>
                </Card.Header>
                <Card.Body>
                  <Card.Title
                    className={`text-capitalize ${
                      rating <= 3 ? "text-danger" : "text-success"
                    }`}
                  >
                    {Array.from({ length: 5 }, (_, i) =>
                      i < rating ? "★" : "☆"
                    )}
                    &nbsp;
                    <strong>{feedback.overview}</strong>
                  </Card.Title>

                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>View Full Feedback</Accordion.Header>
                      <Accordion.Body
                      // style={{ maxHeight: "200px", overflowY: "auto" }}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: feedback.remarks,
                          }}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Card.Body>
                <Card.Footer>
                  <small className="text-muted fs-6">
                    <strong>Email:</strong> {feedback.user_email} <br />
                    <strong>Mobile:</strong> {feedback.user_mobile} <br />
                    <strong>Gym:</strong> {feedback.gym_name || "-"}
                  </small>

                  {isUpdateDelete && (
                    <div className="all-btns lead-btn-axceed mt-2">
                      <div className="lead-log-box">
                        <button
                          type="button"
                          className="lead-log edit-btn"
                          onClick={() =>
                            setModValues((prevs) => ({
                              ...prevs,
                              isModOpen: true,
                              cardName: "edit",
                              rowData: feedback,
                            }))
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil"
                            viewBox="0 0 16 16"
                          >
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                          </svg>
                        </button>

                        <span className="btn-label">Edit</span>
                      </div>

                      <div className="lead-log-box">
                        <button
                          type="button"
                          className="lead-log delete-btn"
                          onClick={(e) => {
                            const filters = {
                              uid: feedback?.uid || "",
                            };
                            handleDelete(filters);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-trash3-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                          </svg>
                        </button>

                        <span className="btn-label">delete</span>
                      </div>
                    </div>
                  )}
                </Card.Footer>
              </Card>
            </Col>
          );
        })
      ) : (
        <div className="mt30">
          <br />
          <span className="info">No Feedback Given Yet!</span>
        </div>
      )}
    </Row>
  );
};

export default FeedbackCards;
